import { Link, NavLink, Outlet } from "react-router-dom";
import { Moon, Sun } from "lucide-react";
import { useSession } from "@/session/SessionProvider";
import { useTheme } from "@/theme/ThemeProvider";

export function AppShell() {
	const { admin, logout } = useSession();
	const { resolved, setTheme } = useTheme();

	return (
		<div className="min-h-svh bg-surface text-fg">
			<header className="border-b border-border bg-surface/80 backdrop-blur sticky top-0 z-10">
				<div className="mx-auto flex max-w-5xl items-center gap-4 px-4 py-3">
					<Link to="/links" className="font-semibold tracking-tight text-accent">
						Shorty
					</Link>
					<nav className="flex gap-3 text-sm">
						<NavLink
							to="/links"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
							end
						>
							Links
						</NavLink>
						<NavLink
							to="/links/new"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
						>
							New
						</NavLink>
						<NavLink
							to="/bookmarklet"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
						>
							Bookmarklet
						</NavLink>
						<NavLink
							to="/blocks"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
						>
							Blocks
						</NavLink>
						<NavLink
							to="/logs"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
						>
							Logs
						</NavLink>
						<NavLink
							to="/ips"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
						>
							IPs
						</NavLink>
						<NavLink
							to="/settings"
							className={({ isActive }) =>
								isActive ? "text-fg font-medium" : "text-fg-muted hover:text-fg"
							}
						>
							Settings
						</NavLink>
					</nav>
					<div className="ml-auto flex items-center gap-3 text-sm text-fg-muted">
						{admin && (
							<span className="hidden sm:inline truncate max-w-[12rem]">
								{admin.email}
							</span>
						)}
						<button
							type="button"
							className="rounded-md p-1.5 hover:bg-surface-raised border border-transparent hover:border-border"
							onClick={() => setTheme(resolved === "dark" ? "light" : "dark")}
							aria-label="Toggle theme"
						>
							{resolved === "dark" ? (
								<Sun className="size-4" />
							) : (
								<Moon className="size-4" />
							)}
						</button>
						<button
							type="button"
							className="text-fg-muted hover:text-fg"
							onClick={() => void logout()}
						>
							Log out
						</button>
					</div>
				</div>
			</header>
			<main className="mx-auto max-w-5xl px-4 py-6">
				<Outlet />
			</main>
			<footer className="mx-auto max-w-5xl px-4 py-6 text-xs text-fg-muted font-mono">
				shorty {typeof __APP_VERSION__ === "undefined" ? "" : __APP_VERSION__}
			</footer>
		</div>
	);
}
